export class ScheduleHAdditionalInformationRegExPattern {
    public static readonly RuleSectionCharacters = '^[A-Za-z0-9 .()-]*$';
}
